export default __webpack_public_path__ + "static/media/warning-line.80c1d5a5.svg";